import { BrowserCacheLocation, InteractionType, LogLevel } from '@azure/msal-browser';
import { Environment } from './environment.model';

export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}
const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1 ||
  window.navigator.userAgent.indexOf('Edge') > -1;

/**
 * This file will be replaced during prod build through the prebuild.js script.
 * That way, prod setting apply for deployed versions.
 */
export const environment: Environment = {
  production: false,
  azureEndpoint: 'https://dev.api.schenck.one',
  apiBaseUrl: 'https://dev.api.schenck.one/mc/v1', // against deployed/cloud backend
  amBaseUrl: 'https://dev.api.schenck.one/am/v1', // against deployed/cloud backend
  usBaseUrl: 'https://dev.api.schenck.one/user', //  for user settings api
  umBaseUrl: 'https://dev.api.schenck.one/um/v2/rights/MC',
  apiVersion: '1.0',
  versionInfo: {
    tag: 'dev',
    hash: '6c71ea035f596372dd703b1ae6e54816ab6ae012',
    buildtimestamp: '2025-12-17T08:25:08.6363357Z',
    buildVersion: '2.0.0+1605',
  },
  msalConfig: {
    msal: {
      auth: {
        clientId: 'eef51796-5047-42ab-8091-d08f24f5e768',
        knownAuthorities: ['durrgroupb2c.b2clogin.com'],
        authority: 'https://durrgroupb2c.b2clogin.com/durrgroupb2c.onmicrosoft.com/B2C_1A_SIGNIN',
        redirectUri: 'https://dev.machinecenter.schenck.one/',
        postLogoutRedirectUri: 'https://dev.machinecenter.schenck.one/postlogout',
      },
      cache: {
        cacheLocation: BrowserCacheLocation.SessionStorage,
        storeAuthStateInCookie: true, // set to true for IE 11. Remove this line to use Angular Universal
      },
      system: {
        loggerOptions: {
          loggerCallback,
          logLevel: LogLevel.Info,
          piiLoggingEnabled: false,
        },
      },
    },
    guard: {
      interactionType: InteractionType.Redirect,
      authRequest: {
        scopes: [
          'https://durrgroupb2c.onmicrosoft.com/ed79441b-4a58-4429-b5cd-233d0f88de57/API.All',
        ],
      },
      loginFailedRoute: '/login-failed',
    },
  },
};
